import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-remove-modal",
  templateUrl: "./remove-modal.component.html",
  standalone: true,
  imports: [
    TranslateModule
  ],
  styleUrls: ["./remove-modal.component.scss"]
})
export class RemoveModalComponent {
  @Input() title!: string;
  @Input() body!: string;
  @Input() confirmButtonText!: string;
  @Input() cancelButtonText!: string;

  constructor(public activeModal: NgbActiveModal) {}

  confirmAndClose(): void {
    this.activeModal.close(true);
  }

  cancelAndClose(): void {
    this.activeModal.close(false);
  }

  closeModal(): void {
    this.activeModal.close();
  }
}
